var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;

function Promise () {
	this._thens = [];
}

Promise.prototype = {
	then: function (onResolve, onReject) 
	{
		this._thens.push({ resolve: onResolve, reject: onReject });
	},

	resolve: function (val) { this._complete('resolve', val); },
	reject: function (ex) { this._complete('reject', ex); },

	_complete: function (which, arg) 
	{
		this.then = which === 'resolve' ?
			function (resolve, reject) { resolve && resolve(arg); } :
			function (resolve, reject) { reject && reject(arg); };

		this.resolve = this.reject = 
			function () { throw new Error('Promise already completed.'); };

		var aThen, i = 0;
		while (aThen = this._thens[i++]) { aThen[which] && aThen[which](arg); }
		delete this._thens;
	}
};

if( typeof window.ReUpLoyalty === 'undefined' )
{
	window.ReUpLoyalty = {}
	window.ReUpLoyalty.nextMessageId = 0;
	window.ReUpLoyalty.requestPromises = {};
	window.ReUpLoyalty.nativeToScriptRequestSucceededCallback = (requestId, response) =>
	{
		if( typeof window.ReUpLoyalty.requestPromises[requestId] !== 'undefined' )
		{
			window.ReUpLoyalty.requestPromises[requestId].resolve(response);
		}
	}

	window.ReUpLoyalty.nativeToScriptRequestFailedCallback = (requestId, errorMessage) =>
	{
		if( typeof window.ReUpLoyalty.requestPromises[requestId] !== 'undefined' )
		{
			window.ReUpLoyalty.requestPromises[requestId].reject(errorMessage);
		}
	}
}

function addPromiseToQueue(p)
{
	window.ReUpLoyalty.requestPromises[window.ReUpLoyalty.nextMessageId] = p;

	return window.ReUpLoyalty.nextMessageId++
}

export function addPayment(name, amount, transactionId, userId, hash, type)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	window.webkit.messageHandlers.addPayment.postMessage({messageId, amount, name, transactionId, userId, hash, type});

	return p;
}

export function addRewardRedemption(name, discount, transactionId, userId, hash, type)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	window.webkit.messageHandlers.addRewardRedemption.postMessage({messageId, discount, name, transactionId, userId, hash, type});

	return p;
}

export function addCheckIn(name, userId, hash, type)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	console.log("{messageId, name, userId, hash, type}",{messageId, name, userId, hash, type})
	window.webkit.messageHandlers.addCheckIn.postMessage({messageId, name, userId, hash, type});

	return p;
}

export function voidPayment(uuid)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	window.webkit.messageHandlers.voidPayment.postMessage({messageId, uuid});

	return p;
}

export function getReceipt()
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	window.webkit.messageHandlers.retrieveReceipt.postMessage({messageId});

	return p;
}

export function getCredentials()
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	window.webkit.messageHandlers.retrieveCredentials.postMessage({messageId});

	return p;
}

export function getTotalAmountOutstanding()
{
	var p = new Promise();
		// window.webkit.messageHandlers.retrieveReceipt.postMessage({});
	if( typeof window.ReUpLoyalty !== 'undefined' )
	{
		setTimeout(function()
		{
			p.resolve((6).toFixed(2));
		},500);	
		// window.ReUpLoyalty.getReceipt((a)=>
		// {
		// 	p.resolve(1);
		// }, (a)=>
		// {
		// 	p.resolve(2);
		// })		
	}
	else
	{
		setTimeout(function()
		{
			p.resolve(window.invoiceTotal.toFixed(2));
		},500);		
	}

	return p;
}

export function retrieveUserDetails()
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	window.webkit.messageHandlers.retrieveUserDetails.postMessage({messageId});

	return p;
}

export function setPageTitles(back, title, right)
{
	var p = new Promise();
	window.webkit.messageHandlers.setPageTitles.postMessage({back, title, right});

	return p;
}

export function close()
{
	window.webkit.messageHandlers.close.postMessage({});
}

export function reUpRPCCall(body)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	window.webkit.messageHandlers.reUpRPCCall.postMessage({messageId, body});

	return p;
}

export function backToScan()
{
	window.webkit.messageHandlers.backToScan.postMessage({});
}
